import { render, staticRenderFns } from "./OccurrenceActionsBar.vue?vue&type=template&id=4571f5bc&scoped=true&"
import script from "./OccurrenceActionsBar.vue?vue&type=script&lang=js&"
export * from "./OccurrenceActionsBar.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceActionsBar.vue?vue&type=style&index=0&id=4571f5bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4571f5bc",
  null
  
)

export default component.exports